import appConfig from '../../config/app';
import { getAuthHeaders } from '../fetchers/auth';

export const getUserFeedback = async (uid) => {
  const response = await fetch(
    `${appConfig.baseApiUrl}/api/v1/users/${uid}/feedback`,
    {
      headers: await getAuthHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch feedback');
  }

  const feedback = await response.json();
  return feedback;
};

export const createFeedback = async ({
  gymUid,
  memberId,
  comment,
  authorId,
  status,
  approvedById,
  approvedOn,
}) => {
  const options = await getAuthHeaders();

  const feedbackPayload = {
    member_id: memberId,
    author_id: authorId,
    comment,
  };

  if (typeof status !== 'undefined') feedbackPayload.status = status;
  if (typeof approvedById !== 'undefined')
    feedbackPayload.approved_by_id = approvedById;
  if (typeof approvedOn !== 'undefined')
    feedbackPayload.approved_on = approvedOn;

  const response = await fetch(
    `${appConfig.baseApiUrl}/api/v1/gyms/${gymUid}/feedback`,
    {
      method: 'POST',
      headers: {
        ...options,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        feedback: feedbackPayload,
      }),
    }
  );

  if (!response.ok) {
    throw new Error('Failed to create feedback');
  }

  const newFeedback = await response.json();
  return newFeedback;
};

export const getPendingFeedback = async (gymUid) => {
  const response = await fetch(
    `${appConfig.baseApiUrl}/api/v1/gyms/${gymUid}/feedback/pending`,
    {
      headers: await getAuthHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch pending feedback');
  }

  const pending = await response.json();
  return pending;
};

export const approveFeedback = async (feedbackId) => {
  const response = await fetch(
    `${appConfig.baseApiUrl}/api/v1/feedback/${feedbackId}/approve`,
    {
      method: 'POST',
      headers: await getAuthHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error('Failed to approve feedback');
  }

  return await response.json();
};

export const rejectFeedback = async (feedbackId) => {
  const response = await fetch(
    `${appConfig.baseApiUrl}/api/v1/feedback/${feedbackId}/reject`,
    {
      method: 'POST',
      headers: await getAuthHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error('Failed to reject feedback');
  }

  return await response.json();
};
